import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <div className="bg-white min-h-screen flex items-center justify-center text-center px-6" data-testid="not-found-page">
      <SEO title="Page Not Found" path="/404" />
      <div>
        <p className="font-mono text-sm text-signal">404</p>
        <h1 className="font-display text-5xl md:text-7xl font-bold tracking-tight mt-4">Off the mesh.</h1>
        <p className="text-zinc-500 mt-4">This page doesn't exist — but the rest of the system does.</p>
        <Link to="/" className="inline-block mt-8 px-7 py-3.5 bg-signal text-white font-medium hover:bg-[#5c8f23] transition-colors" data-testid="not-found-home-btn">
          Back to Home
        </Link>
      </div>
    </div>
  );
}
